import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRequest, postRequest } from "../../axiosRoutes/index";
import SideNavBar from "../sidebar/SideNav";
import HrSideNavBar from "../sidebar/HrSideNavBar";
import {
  Box,
  Button,
  CircularProgress,
  Card,
  Typography,
  Grid,
  Avatar,
  Snackbar,
  Alert,
  CardHeader,
  useMediaQuery,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { useSnackbar } from "../../axiosRoutes/snackbarConfig";
import User from "../../images/User.png";
import { Mail } from "@mui/icons-material";
import profileBackground from '../../images/profileBackground.jpg'
import femaleUser from '../../images/femaleUser.png'
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female';
import BoyOutlinedIcon from '@mui/icons-material/BoyOutlined';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import dayjs from "dayjs";
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EventIcon from '@mui/icons-material/Event';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Inventory2Icon from '@mui/icons-material/Inventory2';

const EmployeeProfile = () => {
  const { snackbar, showSnackbar, handleSnackbarClose } = useSnackbar();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const { id, user } = location.state || {};
  const [medicalSum, setMedicalSum] = useState(0);
  const [fitnessSum, setFitnessSum] = useState(0);
  const [leaves, setLeaves] = useState([]);
  const [projects, setProjects] = useState([]);
  const [inventory, setInventory] = useState([]);
  const role = localStorage.getItem("role");
  const [salaryData, setSalaryData] = useState({
    userId: "",
    currency: "",
    deduction: 0,
    netSalary: "",
    fullMonth: "",
    salaryMonth: "",
    tax: 0,
  });
  const [employee, setEmployee] = useState({
    empId: "",
    name: "",
    email: "",
    designation: "",
    phone: "",
    dob: "",
    address: "",
    joiningDate: "",
    joiningMonth: "",
    experience: "",
    salary: "",
  });
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [showSalary, setShowSalary] = useState(false)

  useEffect(() => {
    const fetchEmployees = async () => {
      const access = localStorage.getItem("access");
      try {
        const response = await getRequest(`employee/${id}`, {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        });
        const birthDate = new Date(response.dob).toISOString().split("T")[0];
        const joining = new Date(response.joiningDate).toLocaleDateString(
          "en-US",
          {
            day: "2-digit",
            month: "long",
            year: "numeric",
          }
        );
        const month = new Date(response.joiningDate).toLocaleDateString(
          "en-US",
          {
            month: "long",
            year: "numeric",
          }
        );
        const calculateExperience = (joiningDate) => {
          const startDate = new Date(joiningDate);
          const currentDate = new Date();
          let years = currentDate.getFullYear() - startDate.getFullYear();
          let months = currentDate.getMonth() - startDate.getMonth();
          if (
            months < 0 ||
            (months === 0 && currentDate.getDate() < startDate.getDate())
          ) {
            years--;
            months += 12;
          }
          if (years === 0) {
            return `${months} month${months !== 1 ? "s" : ""}`;
          }
          return `${years} year${years !== 1 ? "s" : ""} ${months > 0 ? `${months} month${months !== 1 ? "s" : ""}` : ""
            }`;
        };
        const experience = calculateExperience(response.joiningDate);
        setEmployee((prevData) => ({
          ...prevData,
          empId: response._id,
          name: response.name,
          email: response.email,
          designation: response.designation,
          phone: response.phone,
          gender: response.gender,
          dob: birthDate,
          age: dayjs().diff(dayjs(birthDate), "year"),
          address: response.address,
          joiningDate: joining,
          joiningMonth: month,
          status: response.status,
          salary: response.salary,
          experience: experience,
        }));
      } catch (error) {
        console.error("Error fetching employee:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEmployees();
  }, [id]);

  useEffect(() => {
    const fetchSalary = async (id) => {
      try {
        const date = new Date();
        const mon = date.getMonth() + 1;
        const year = date.getFullYear();
        const month = `${mon}/${year}`;
        const access = localStorage.getItem("access");
        const res = await postRequest(
          `admin/salary/user/${id}`,
          {
            Authorization: `Bearer ${access}`,
          },
          { salaryMonth: month }
        );
        const [curMonth, curYear] = res.data.salaryMonth.split("/");
        const curDate = new Date(`${curYear}-${curMonth}-01`);
        const formattedMonth = curDate.toLocaleDateString("en-US", {
          month: "long",
          year: "numeric",
        });
        setSalaryData((prevData) => ({
          ...prevData,
          userId: res.data.userId,
          currency: res.data.currency,
          deduction: res.data.deduction,
          netSalary: res.data.netSalary,
          fullMonth: formattedMonth,
          salaryMonth: res.data.salaryMonth,
          tax: res.data.tax,
        }));
      } catch (error) {
        console.error("Error Fetching Salary", error);
      }
    };
    fetchSalary(id);
  }, [id]);

  useEffect(() => {
    const fetchFitness = async () => {
      const access = localStorage.getItem("access");
      try {
        const response = await getRequest(
          `admin/fitnessAllowance/user/${user}`,
          {
            headers: {
              Authorization: `Bearer ${access}`,
            },
          }
        );
        const now = new Date();
        const currentMonth = now.getMonth() + 1;
        const currentYear = now.getFullYear();
        const sum = response?.data
          .filter((fitness) => {
            const date = new Date(fitness.date);
            const fitnessMonth = date.getMonth() + 1;
            const fitnessYear = date.getFullYear();
            return (
              fitness.status === "approved" &&
              fitnessMonth === currentMonth &&
              fitnessYear === currentYear
            );
          })
          .reduce((total, fitness) => total + fitness.amountReimbursed, 0);

        setFitnessSum(sum);
      } catch (error) {
        console.error("Error fetching Fitness Allowances:", error);
      }
    };
    fetchFitness();
  }, [user]);

  useEffect(() => {
    const fetchProjects = async () => {
      const access = localStorage.getItem("access");
      try {
        const response = await getRequest(`employee/project/user/${user}`, {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        });
        setProjects(response);
      } catch (error) {
        console.error("Error fetching Projects:", error);
      }
    };
    fetchProjects();
  }, [user]);

  useEffect(() => {
    const fetchInventory = async () => {
      const access = localStorage.getItem("access");
      try {
        const response = await getRequest(`admin/inventory/user/${user}`, {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        });
        setInventory(response);
      } catch (error) {
        console.error("Error fetching inventory:", error);
      }
    };
    fetchInventory();
  }, [user]);

  useEffect(() => {
    const fetchMedicals = async () => {
      const access = localStorage.getItem("access");
      try {
        const response = await getRequest(
          `admin/medicalAllowance/user/${user}?fiscalYear=true`,
          {
            headers: {
              Authorization: `Bearer ${access}`,
            },
          }
        );
        const sum = response?.data
          .filter((medical) => medical.status === "approved")
          .reduce((total, medical) => total + medical.amount, 0);
        setMedicalSum(sum);
      } catch (error) {
        console.error("Error fetching Medical Allowances:", error);
      }
    };
    fetchMedicals();
  }, [user]);

  useEffect(() => {
    const access = localStorage.getItem("access");
    const curYear = new Date().getFullYear();
    if (user !== null) {
      console.log("user id in leaves", user);
      const fetchLeaves = async (user) => {
        try {
          const res = await postRequest(
            `admin/leave/yearly/${user}`,
            {
              Authorization: `Bearer ${access}`,
            },
            { year: curYear }
          );
          setLeaves(res.data);
        } catch (error) {
          console.error("Error fetching Yearly Leave: ", error);
        }
      };
      fetchLeaves(user);
    }
  }, [user]);

  const handleMail = async (id, month) => {
    try {
      const access = localStorage.getItem("access");
      const res = await postRequest(
        `admin/salary/${id}`,
        {
          Authorization: `Bearer ${access}`,
        },
        { salaryMonth: month }
      );
      showSnackbar(res.data, "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <CircularProgress size={50} sx={{ color: "#FF5722" }} />
        <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <div className="app-container" style={{ color: "#fff", display: "flex" }}>
        {role === "admin" && <SideNavBar />}
        {role === "hr" && <HrSideNavBar />}
        <div
          style={{
            flex: 1,
            margin: `${
              isSmallScreen
                ? "3.2rem 0.3rem 0.5rem 0.3rem"
                : "0rem 0.5rem 0rem 0.5rem"
            }`,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#000",
              padding: { xs: 2, md: 4 },
              marginTop: { xs: 4, md: 2 },
              ...(!isSmallScreen && {
                minHeight: '91vh',
                display: "flex",
                alignItems: "center",
              }),
            }}
          >
            <Grid
              container
              spacing={3}
            >
              <Grid item xs={12} md={4}>
                {/* <div style={{ borderBottom: "4rem solid #FF5722" }}></div> */}
                <Card
                  sx={{
                    backgroundColor: "#1a1a1a",
                    color: "#fff",
                    padding: { xs: 0, md: 0 },
                    borderRadius: "20px",
                    paddingBottom: "0px",
                  }}
                >
                  <Box
                    sx={{
                      height: 150,
                      width: "100%",
                      // backgroundColor: "#FF5722",
                      backgroundImage: `url(${profileBackground})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                  <Box
                    sx={{
                      p: "20px",
                      position: "relative",
                      m: "0",
                      height: "100%",
                    }}
                  >
                    <Avatar
                      src={employee?.gender === "male" ? User : femaleUser}
                      variant="circular"
                      sx={{
                        width: { xs: 100, md: 120 },
                        height: { xs: 100, md: 120 },
                        padding: "0px",
                        border: "3px solid white",
                        position: "absolute",
                        top: -55,
                        left: 16,
                        "& img": {
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                        },
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{
                        paddingTop: !isSmallScreen ? "70px" : "50px",
                        fontSize: { xs: "1.3rem", md: "1.8rem" },
                      }}
                    >
                      <b>{employee.name}</b>
                    </Typography>
                    <Typography variant="subtitle1" mt={1}>
                      {employee.designation}
                    </Typography>
                    <Typography
                      variant="h1"
                      sx={{
                        mt: "15px",
                        fontSize: { xs: "1.2rem", md: "1.6rem" },
                      }}
                    >
                      <b>Basic Information</b>
                    </Typography>
                    <Grid
                      container
                      direction="column"
                      mt={2}
                      spacing={1}
                      sx={{ marginTop: "0px" }}
                    >
                      <Card
                        sx={{
                          bgcolor: "transparent",
                          boxShadow: "none",
                          paddingLeft: "8px",
                          width: "100%",
                        }}
                      >
                        <CardHeader
                          sx={{
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            wordBreak: "break-word",   
                            overflowWrap: "anywhere",  
                            maxWidth: "100%",
                          }}
                          avatar={
                            <Avatar
                              sx={{
                                bgcolor: "#FF5722",
                                width: "35px",
                                height: "35px",
                              }}
                              aria-label="recipe"
                            >
                              <EmailIcon
                                style={{
                                  fontSize: 23,
                                  backgroundColor: "#FF5722",
                                  borderRadius: "50px",
                                  padding: "4px",
                                }}
                              />
                            </Avatar>
                          }
                          title={
                            <>
                              <Typography
                                variant="body2"
                                color="white"
                                sx={{ fontSize: "12px", width: "100%" }}
                              >
                                Email
                              </Typography>
                              <Typography
                                variant="h6"
                                color="white"
                                sx={{
                                  fontSize: "16px",
                                  wordWrap: "break-word",
                                }}
                              >
                                {employee.email}
                              </Typography>
                            </>
                          }
                        />
                      </Card>
                      <Card
                        sx={{
                          maxWidth: 345,
                          bgcolor: "transparent",
                          boxShadow: "none",
                          paddingLeft: "8px",
                        }}
                      >
                        <CardHeader
                          sx={{
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            paddingTop: "0px",
                          }}
                          avatar={
                            <Avatar
                              sx={{
                                bgcolor: "#FF5722",
                                width: "35px",
                                height: "35px",
                              }}
                              aria-label="recipe"
                            >
                              <PhoneIcon
                                style={{
                                  fontSize: 23,
                                  backgroundColor: "#FF5722",
                                  borderRadius: "50px",
                                  padding: "4px",
                                }}
                              />
                            </Avatar>
                          }
                          title={
                            <>
                              <Typography
                                variant="body2"
                                color="white"
                                sx={{ fontSize: "12px" }}
                              >
                                Mobile Phone
                              </Typography>
                              <Typography
                                variant="h6"
                                color="white"
                                sx={{ fontSize: "16px" }}
                              >
                                {employee.phone}
                              </Typography>
                            </>
                          }
                        />
                      </Card>
                      <Card
                        sx={{
                          maxWidth: 345,
                          bgcolor: "transparent",
                          boxShadow: "none",
                          paddingLeft: "8px",
                        }}
                      >
                        <CardHeader
                          sx={{
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            paddingTop: "0px",
                          }}
                          avatar={
                            <Avatar
                              sx={{
                                bgcolor: "#FF5722",
                                width: "35px",
                                height: "35px",
                              }}
                              aria-label="recipe"
                            >
                              {employee.gender === "male" ? (
                                <MaleIcon
                                  style={{
                                    fontSize: 26,
                                    backgroundColor: "#FF5722",
                                    borderRadius: "50px",
                                    padding: "4px",
                                  }}
                                />
                              ) : (
                                <FemaleIcon
                                  style={{
                                    fontSize: 28,
                                    backgroundColor: "#FF5722",
                                    borderRadius: "50px",
                                    padding: "4px",
                                  }}
                                />
                              )}
                            </Avatar>
                          }
                          title={
                            <>
                              <Typography
                                variant="body2"
                                color="white"
                                sx={{ fontSize: "12px" }}
                              >
                                Gender
                              </Typography>
                              <Typography
                                variant="h6"
                                color="white"
                                sx={{ fontSize: "16px" }}
                              >
                                {employee?.gender?.charAt(0).toUpperCase() +
                                  employee?.gender?.slice(1)}
                              </Typography>
                            </>
                          }
                        />
                      </Card>
                      <Card
                        sx={{
                          maxWidth: 345,
                          bgcolor: "transparent",
                          boxShadow: "none",
                          paddingLeft: "8px",
                        }}
                      >
                        <CardHeader
                          sx={{
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            paddingTop: "0px",
                          }}
                          avatar={
                            <Avatar
                              sx={{
                                bgcolor: "#FF5722",
                                width: "35px",
                                height: "35px",
                              }}
                              aria-label="recipe"
                            >
                              <BoyOutlinedIcon
                                style={{
                                  fontSize: 38,
                                  backgroundColor: "#FF5722",
                                  borderRadius: "50px",
                                  padding: "4px",
                                }}
                              />
                            </Avatar>
                          }
                          title={
                            <>
                              <Typography
                                variant="body2"
                                color="white"
                                sx={{ fontSize: "12px" }}
                              >
                                Age
                              </Typography>
                              <Typography
                                variant="h6"
                                color="white"
                                sx={{ fontSize: "16px" }}
                              >
                                {employee.age}
                              </Typography>
                            </>
                          }
                        />
                      </Card>
                      <Card
                        sx={{
                          maxWidth: 345,
                          bgcolor: "transparent",
                          boxShadow: "none",
                          paddingLeft: "8px",
                        }}
                      >
                        <CardHeader
                          sx={{
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            paddingTop: "0px",
                          }}
                          avatar={
                            <Avatar
                              sx={{
                                bgcolor: "#FF5722",
                                width: "35px",
                                height: "35px",
                              }}
                              aria-label="recipe"
                            >
                              <GroupAddIcon
                                style={{
                                  fontSize: 23,
                                  backgroundColor: "#FF5722",
                                  borderRadius: "50px",
                                  padding: "4px",
                                }}
                              />
                            </Avatar>
                          }
                          title={
                            <>
                              <Typography
                                variant="body2"
                                color="white"
                                sx={{ fontSize: "12px" }}
                              >
                                Status
                              </Typography>
                              <Typography
                                variant="h6"
                                color="white"
                                sx={{ fontSize: "16px" }}
                              >
                                {employee?.status?.charAt(0).toUpperCase() +
                                  employee?.status?.slice(1)}
                              </Typography>
                            </>
                          }
                        />
                      </Card>
                      <Card
                        sx={{
                          maxWidth: 345,
                          bgcolor: "transparent",
                          boxShadow: "none",
                          paddingLeft: "8px",
                        }}
                      >
                        <CardHeader
                          sx={{
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            paddingTop: "0px",
                          }}
                          avatar={
                            <Avatar
                              sx={{
                                bgcolor: "#FF5722",
                                width: "35px",
                                height: "35px",
                              }}
                              aria-label="recipe"
                            >
                              <WorkHistoryOutlinedIcon
                                style={{
                                  fontSize: 23,
                                  backgroundColor: "#FF5722",
                                  padding: "0px",
                                }}
                              />
                            </Avatar>
                          }
                          title={
                            <>
                              <Typography
                                variant="body2"
                                color="white"
                                sx={{ fontSize: "12px" }}
                              >
                                Experience
                              </Typography>
                              <Typography
                                variant="h6"
                                color="white"
                                sx={{ fontSize: "16px" }}
                              >
                                {employee?.experience}
                              </Typography>
                            </>
                          }
                        />
                      </Card>
                    </Grid>
                  </Box>
                </Card>
              </Grid>
              <Grid xs={12} md={8}>
                <Grid
                  sx={{
                    backgroundColor: "#1a1a1a",
                    marginLeft: "24px",
                    marginTop: "24px",
                    borderRadius: "20px",
                    overflow: "hidden",
                  }}
                >
                  {" "}
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      padding: "20px",
                      backgroundColor: "#313131ff",
                    }}
                  >
                    <Grid
                      sx={{
                        display: "flex",
                        gap: "15px",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      <Grid
                        sx={{
                          borderRadius: "50%",
                          width: "35px",
                          minWidth: "35px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "#FF5722",
                        }}
                      >
                        <AccountBoxOutlinedIcon sx={{ fontSize: "26px" }} />
                      </Grid>{" "}
                      <Grid sx={{ fontSize: "26px" }}>Information</Grid>
                    </Grid>
                    <Grid>
                      <Box
                        ml="auto"
                        display="flex"
                        gap="1rem"
                        sx={{ marginLeft: "10px" }}
                      >
                        {salaryData.userId !== "" && (
                          <Button
                            variant="outlined"
                            startIcon={<Mail />}
                            onClick={() => handleMail(salaryData.userId, salaryData.salaryMonth)}
                            sx={{
                              color: "#fff",
                              borderColor: "#fff",
                              "&:hover": {
                                backgroundColor: "#FF5722",
                                color: "white",
                                border: "none",
                              },
                            }}
                          >
                            Salary Slip
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      margin: "0px 65px",
                      padding: "20px 0px",
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid rgba(41, 40, 40, 1)",
                    }}
                  >
                    <Grid>Gross Salary</Grid>
                    <Grid
                      sx={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {showSalary ? employee.salary : "●●●●●"}{" "}
                      {!showSalary ? (
                        <VisibilityOffIcon
                          style={{ marginLeft: "10px", cursor: "pointer" }}
                          onClick={() => setShowSalary(!showSalary)}
                        />
                      ) : (
                        <VisibilityIcon
                          style={{ marginLeft: "10px", cursor: "pointer" }}
                          onClick={() => setShowSalary(!showSalary)}
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      margin: "0px 65px",
                      padding: "20px 0px",
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid rgba(41, 40, 40, 1)",
                    }}
                  >
                    <Grid>Date of birth</Grid>
                    <Grid>{employee.dob}</Grid>
                  </Grid>
                  <Grid
                    sx={{
                      margin: "0px 65px",
                      padding: "20px 0px",
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid rgba(41, 40, 40, 1)",
                    }}
                  >
                    <Grid>Address</Grid>
                    <Grid sx={{ marginLeft: "10px", textAlign: "end" }}>
                      {employee.address}
                    </Grid>
                  </Grid>
                </Grid>{" "}
                <Grid
                  sx={{
                    backgroundColor: "#1a1a1a",
                    marginLeft: "24px",
                    marginTop: "24px",
                    borderRadius: "20px",
                    overflow: "hidden",
                  }}
                >
                  {" "}
                  <Accordion
                    sx={{
                      backgroundColor: "#1a1a1a",
                      color: "white",
                    }}
                  >
                    <AccordionSummary
                      sx={{
                        backgroundColor: "#313131ff",
                        padding: "10px 20px",
                      }}
                      expandIcon={
                        <ArrowDropDownIcon style={{ color: "white" }} />
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Grid
                        sx={{
                          display: "flex",
                          gap: "15px",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <Grid
                          sx={{
                            borderRadius: "50%",
                            width: "35px",
                            minWidth: "35px",
                            height: "35px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#FF5722",
                          }}
                        >
                          <EventIcon />
                        </Grid>{" "}
                        <Grid sx={{ fontSize: "26px" }}>Attendance Status</Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: "0px" }}>
                      <Grid
                        sx={{
                          margin: "0px 65px",
                          padding: "20px 0px",
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "1px solid rgba(41, 40, 40, 1)",
                        }}
                      >
                        <Grid>Leave Status</Grid>
                        <Grid
                          sx={{
                            marginLeft: "20px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {leaves.total_leaves ?? 0}
                        </Grid>
                      </Grid>
                      <Grid
                        sx={{
                          margin: "0px 65px",
                          padding: "20px 0px",
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "1px solid rgba(41, 40, 40, 1)",
                        }}
                      >
                        <Grid>Half Day Status</Grid>
                        <Grid>{leaves.half_day ?? 0}</Grid>
                      </Grid>
                      <Grid
                        sx={{
                          margin: "0px 65px",
                          padding: "20px 0px",
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "1px solid rgba(41, 40, 40, 1)",
                        }}
                      >
                        <Grid>Work From Home Status</Grid>
                        <Grid>{leaves.work_from_home ?? 0}</Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>{" "}
                </Grid>{" "}
                <Grid
                  sx={{
                    backgroundColor: "#1a1a1a",
                    marginLeft: "24px",
                    marginTop: "24px",
                    borderRadius: "20px",
                    overflow: "hidden",
                  }}
                >
                  {" "}
                  <Accordion
                    sx={{
                      backgroundColor: "#1a1a1a",
                      color: "white",
                    }}
                  >
                    <AccordionSummary
                      sx={{
                        backgroundColor: "#313131ff",
                        padding: "10px 20px",
                      }}
                      expandIcon={
                        <ArrowDropDownIcon style={{ color: "white" }} />
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Grid
                        sx={{
                          display: "flex",
                          gap: "15px",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <Grid
                          sx={{
                            borderRadius: "50%",
                            width: "35px",
                            minWidth: "35px",
                            height: "35px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#FF5722",
                          }}
                        >
                          <ReceiptLongIcon sx={{ fontSize: "24px", marginRight: '2px' }} />
                        </Grid>{" "}
                        <Grid sx={{ fontSize: "26px" }}>Allowance Status</Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: "0px" }}>
                      <Grid
                        sx={{
                          margin: "0px 65px",
                          padding: "20px 0px",
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "1px solid rgba(41, 40, 40, 1)",
                        }}
                      >
                        <Grid>Medical Allowance</Grid>
                        <Grid
                          sx={{
                            marginLeft: "20px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {medicalSum}/50000
                        </Grid>
                      </Grid>
                      <Grid
                        sx={{
                          margin: "0px 65px",
                          padding: "20px 0px",
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "1px solid rgba(41, 40, 40, 1)",
                        }}
                      >
                        <Grid>Fitness Allowance</Grid>
                        <Grid>{fitnessSum}</Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>{" "}
                </Grid>{" "}
                <Grid
                  sx={{
                    backgroundColor: "#1a1a1a",
                    marginLeft: "24px",
                    marginTop: "24px",
                    borderRadius: "20px",
                    overflow: "hidden",
                  }}
                >
                  {" "}
                  <Accordion
                    sx={{
                      backgroundColor: "#1a1a1a",
                      color: "white",
                    }}
                  >
                    <AccordionSummary
                      sx={{
                        backgroundColor: "#313131ff",
                        padding: "10px 20px",
                      }}
                      expandIcon={
                        <ArrowDropDownIcon style={{ color: "white" }} />
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Grid
                        sx={{
                          display: "flex",
                          gap: "15px",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <Grid
                          sx={{
                            borderRadius: "50%",
                            width: "35px",
                            minWidth: "35px",
                            height: "35px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#FF5722",
                          }}
                        >
                          <AssignmentIcon sx={{ fontSize: "22px" }} />
                        </Grid>{" "}
                        <Grid sx={{ fontSize: "26px" }}>Projects</Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: "0px" }}>
                      {projects && projects.length > 0 ? (
                        projects.map((project, index) => (
                          <Grid
                            sx={{
                              margin: "0px 65px",
                              padding: "20px 0px",
                              display: "flex",
                              justifyContent: "space-between",
                              borderBottom: "1px solid rgba(41, 40, 40, 1)",
                            }}
                          >
                            <Grid
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <Typography
                                key={project.id}
                                sx={{ fontSize: { xs: "13px", md: "15px" } }}
                              >
                                <span style={{ color: "#FF5722" }}>
                                  {index + 1}
                                </span>
                                <span style={{ marginLeft: "1rem" }}>
                                  {project.title}
                                </span>
                              </Typography>
                            </Grid>
                          </Grid>
                        ))
                      ) : (
                        <Grid
                          sx={{
                            margin: "0px 65px",
                            padding: "20px 0px",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px solid rgba(41, 40, 40, 1)",
                          }}
                        >
                          <Grid sx={{ display: "flex", alignItems: "center" }}>
                            <Typography
                              sx={{ fontSize: { xs: "13px", md: "15px" } }}
                            >
                              Not Any Project Assigned Yet
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </AccordionDetails>
                  </Accordion>{" "}
                </Grid>{" "}
                <Grid
                  sx={{
                    backgroundColor: "#1a1a1a",
                    marginLeft: "24px",
                    marginTop: "24px",
                    borderRadius: "20px",
                    overflow: "hidden",
                  }}
                >
                  {" "}
                  <Accordion
                    sx={{
                      backgroundColor: "#1a1a1a",
                      color: "white",
                    }}
                  >
                    <AccordionSummary
                      sx={{
                        backgroundColor: "#313131ff",
                        padding: "10px 20px",
                      }}
                      expandIcon={
                        <ArrowDropDownIcon style={{ color: "white" }} />
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Grid
                        sx={{
                          display: "flex",
                          gap: "15px",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <Grid
                          sx={{
                            borderRadius: "50%",
                            width: "35px",
                            minWidth: "35px",
                            height: "35px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#FF5722",
                          }}
                        >
                          <Inventory2Icon sx={{ fontSize: "22px" }} />
                        </Grid>{" "}
                        <Grid sx={{ fontSize: "26px" }}>Inventory</Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: "0px" }}>
                      {inventory && inventory.length > 0 ? (
                        inventory.map((item, index) => (
                          <Grid
                            sx={{
                              margin: "0px 65px",
                              padding: "20px 0px",
                              display: "flex",
                              justifyContent: "space-between",
                              borderBottom: "1px solid rgba(41, 40, 40, 1)",
                            }}
                          >
                            <Grid
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <Typography
                                key={item.id}
                                sx={{ fontSize: { xs: "13px", md: "15px" } }}
                              >
                                <span style={{ color: "#FF5722" }}>
                                  {index + 1}
                                </span>
                                <span style={{ marginLeft: "1rem" }}>
                                  {item.title}
                                </span>
                              </Typography>
                            </Grid>
                          </Grid>
                        ))
                      ) : (
                        <Grid
                          sx={{
                            margin: "0px 65px",
                            padding: "20px 0px",
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px solid rgba(41, 40, 40, 1)",
                          }}
                        >
                          <Grid sx={{ display: "flex", alignItems: "center" }}>
                            <Typography
                              sx={{ fontSize: { xs: "13px", md: "15px" } }}
                            >
                              Not Any Project Assigned Yet
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </AccordionDetails>
                  </Accordion>{" "}
                </Grid>{" "}
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
                        
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EmployeeProfile;
